import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import ReportProntuario from '../../../pages/prontuario/ReportProntuario';
import history from '../../../services/history';

const dropdownItemStyle = {
  paddingTop: 1,
  paddingBottom: 1,
  fontSize: '0.95em',
};

const ECO_PROCEDURES = [11, 712, 713, 714];
const EMPTY_ATIVIDADE = {};
const EMPTY_ACTIONS = {};

const AtividadeActionsDropdown = React.memo(
  ({ atividade = EMPTY_ATIVIDADE, actions = EMPTY_ACTIONS }) => {
    const [showReportProntuario, setShowReportProntuario] = useState(false);
    const {
      handleLaudar,
      handleLaudarCongenitoTXT,
      setShowUpload,
      setAtividade,
      handleLiberarLaudo,
      setShowReceitaModal,
      handleImprimir,
      handleImprimirTXT,
      handleEspelhoDoppler,
      handleEspelhoFisio,
      handleEspelhoFarmaco,
      handleImprimirEspelho,
      handleAtualizarGuiaConvenio,
    } = actions;

    const codProcedi = atividade.CODPROCEDI;
    const isEcoProcedure = ECO_PROCEDURES.includes(codProcedi);

    return (
      <>
        <Dropdown>
          <Dropdown.Toggle size="sm" variant="success" />
          <Dropdown.Menu style={{ zIndex: 1050 }}>
            {/* Opções de Laudo */}
            {typeof handleLaudar === 'function' &&
              (isEcoProcedure ? (
                <>
                  <Dropdown.Item
                    onClick={() => handleLaudar(atividade)}
                    style={dropdownItemStyle}
                  >
                    Laudar Eco
                  </Dropdown.Item>
                  {typeof handleLaudarCongenitoTXT === 'function' && (
                    <Dropdown.Item
                      onClick={() => handleLaudarCongenitoTXT(atividade)}
                      style={dropdownItemStyle}
                    >
                      Laudar Congênito TXT
                    </Dropdown.Item>
                  )}
                </>
              ) : (
                <Dropdown.Item
                  onClick={() => handleLaudar(atividade)}
                  style={dropdownItemStyle}
                >
                  Laudar
                </Dropdown.Item>
              ))}

            {/* Anexos */}
            {codProcedi === 3 && typeof handleLaudar === 'function' ? (
              <Dropdown.Item
                onClick={() => history.push(`/formEcg/${atividade.CODLAUDO}`)}
                style={dropdownItemStyle}
              >
                Anexar ECG
              </Dropdown.Item>
            ) : (
              typeof setShowUpload === 'function' &&
              typeof setAtividade === 'function' && (
                <Dropdown.Item
                  onClick={() => {
                    setShowUpload(true);
                    setAtividade(atividade);
                  }}
                  style={dropdownItemStyle}
                >
                  Anexar Arquivo
                </Dropdown.Item>
              )
            )}

            {/* Liberação e Receitas */}
            {typeof handleLiberarLaudo === 'function' && (
              <>
                <Dropdown.Item
                  onClick={() => handleLiberarLaudo(atividade, 'SIM')}
                  style={dropdownItemStyle}
                >
                  Liberar Laudo
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => handleLiberarLaudo(atividade, 'NAO')}
                  style={dropdownItemStyle}
                >
                  Laudo NAO Liberado
                </Dropdown.Item>
              </>
            )}

            {typeof setShowReceitaModal === 'function' && (
              <Dropdown.Item
                onClick={() => setShowReceitaModal(true)}
                style={dropdownItemStyle}
              >
                Emitir Receita
              </Dropdown.Item>
            )}

            <Dropdown.Divider />

            {/* Impressões e Espelhos por tipo de exame */}
            {isEcoProcedure ? (
              <>
                {typeof handleImprimir === 'function' && (
                  <>
                    <Dropdown.Item
                      onClick={() => handleImprimir(atividade, false)}
                      style={dropdownItemStyle}
                    >
                      Imprimir
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handleImprimir(atividade, true)}
                      style={dropdownItemStyle}
                    >
                      Imprimir Timbrado
                    </Dropdown.Item>
                  </>
                )}
                {typeof handleImprimirTXT === 'function' && (
                  <Dropdown.Item
                    onClick={() => handleImprimirTXT(atividade)}
                    style={dropdownItemStyle}
                  >
                    ImprimirTXT
                  </Dropdown.Item>
                )}
                {typeof handleEspelhoDoppler === 'function' && (
                  <Dropdown.Item
                    onClick={() => handleEspelhoDoppler(atividade)}
                    style={dropdownItemStyle}
                  >
                    Espelho
                  </Dropdown.Item>
                )}
              </>
            ) : codProcedi === 13 ? (
              <>
                {typeof handleImprimir === 'function' && (
                  <Dropdown.Item
                    onClick={() => handleImprimir(atividade, false)}
                    style={dropdownItemStyle}
                  >
                    Imprimir
                  </Dropdown.Item>
                )}
                {typeof handleEspelhoFisio === 'function' && (
                  <Dropdown.Item
                    onClick={() => handleEspelhoFisio(atividade)}
                    style={dropdownItemStyle}
                  >
                    Espelho Fisio
                  </Dropdown.Item>
                )}
                {typeof handleEspelhoFarmaco === 'function' && (
                  <Dropdown.Item
                    onClick={() => handleEspelhoFarmaco(atividade)}
                    style={dropdownItemStyle}
                  >
                    Espelho Farmaco
                  </Dropdown.Item>
                )}
              </>
            ) : (
              <>
                {typeof handleImprimir === 'function' && (
                  <>
                    <Dropdown.Item
                      onClick={() => handleImprimir(atividade, false)}
                      style={dropdownItemStyle}
                    >
                      Imprimir
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handleImprimir(atividade, true)}
                      style={dropdownItemStyle}
                    >
                      Imprimir Timbrado
                    </Dropdown.Item>
                  </>
                )}
                {typeof handleImprimirEspelho === 'function' && (
                  <Dropdown.Item
                    onClick={() => handleImprimirEspelho(atividade)}
                    style={dropdownItemStyle}
                  >
                    Imprimir Espelho
                  </Dropdown.Item>
                )}
              </>
            )}

            <Dropdown.Divider />

            {/* Guia do Convênio e Prontuário */}
            {typeof handleAtualizarGuiaConvenio === 'function' && (
              <Dropdown.Item
                onClick={() => handleAtualizarGuiaConvenio(atividade)}
                style={dropdownItemStyle}
              >
                Atualizar Guia Convênio
              </Dropdown.Item>
            )}

            {[1, 58, 800].includes(codProcedi) && (
              <Dropdown.Item
                onClick={() => setShowReportProntuario(true)}
                style={dropdownItemStyle}
              >
                Medicações e Conduta
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>

        {showReportProntuario && (
          <ReportProntuario
            id={atividade.CODLAUDO}
            onHide={() => setShowReportProntuario(false)}
          />
        )}
      </>
    );
  });

export default AtividadeActionsDropdown;
